import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = createClient({
    projectId: "b5bw3cbh",
    dataset: "production",
    apiVersion: "2023-07-03",
    useCdn: true,
    token: process.env.PROJECT_TOKEN,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
